import React, { Fragment, useEffect, useState, useCallback } from "react";
import connect from "react-redux/lib/connect/connect";
import { SetPageInfo } from "../../common/actions/pageAction";
import { GetIframeUrl, GetSportsList } from "../../common/actions/sportsAction";
import store from "../../common/store";
import {
  clearInfiniteScroll,
  convertGameType,
  fixBetGameData,
  groupBetGameEvents,
  isEmpty,
  isMobilePage,
  mobileSportsListScrollHandler,
  mobileSportsWindowScrollHandler,
  pcSportScrollHandler,
  ResizeESportsIframe,
  ResizeSportsLiveIframe,
} from "../../common/cores";
import { per_page } from "../../common/cores/keys";
import { socket } from "../../common/cores/socket";
import Markets from "./Markets";
import Match from "./Match";
import Swipbox from "./Swipbox";
import Pagenation from "../common/Pagenation";
import {
  getEventParttName,
  getMarketName,
} from "../../common/actions/userActions";
import $ from "jquery";
import { sportPerPage } from "../../utils";
import { SetCurrentPage, SetPerPage } from "../../common/actions/pageAction";
import {
  AddSportsList,
  SetLeague,
  SetLocation,
} from "../../common/actions/sportsAction";

const SportsCenter = (props) => {
  const roomObj = props.roomObj;

  const {
    type,
    sportsData,
    location,
    league,
    sportId,
    bet_setting,
    pageInfo,
    totalPage,
    url,
    isUp,
    page,
    searchType,
    searchValue,
  } = props;

  const [sort, setSort] = useState("time");
  const [esport, setEsport] = useState("prematch");
  const [pages, setPages] = useState(1);
  const [showMarkets, setShowMarkets] = useState(
    window.screen.width > 800 ? true : false
  );
  const [interiorShowMarket, setInteriorShowMarket] = useState(-1);
  const [showMatch, setShowMatch] = useState(true);

  const listStyle = {
    float: "left",
    width: "100%",
    margin: "0 0 0 0",
    display: "block",
    overflow: "auto",
    // minHeight: type == "prematch" ? "550px" : "50px",
    // maxHeight : type == "prematch" ? '630px' : '200px'
  };

  const onInteriorShowMarket = (index) => {
    if (interiorShowMarket === index) {
      setInteriorShowMarket(-1);
    } else {
      setInteriorShowMarket(index);
    }
  };

  useEffect(() => {
    getMarketName();
    getEventParttName();
    props.SetCurrentPage({ page: pages, ...totalPage });
  }, []);

  useEffect(() => {
    props.SetCurrentPage({ page: pages, ...totalPage });
  }, [pages]);

  let gamelists = sportsData;

  const getSportsList = (page) => {
    const params = {
      ...roomObj,
      sportId: props.type === "esports" ? "all" : sportId.toString(),
      esportType: props.type === "esports" ? sportId.toString() : "all",
      sort: sort,
      location: location,
      league: league,
      page: page,
      searchType: searchType,
      searchValue: searchValue,
      perPage: sportPerPage,
      gameType: roomObj.gameType,
    };
    props.AddSportsList(params, page.curPage == 1, page.curPage != 1);
  };

  const onSort = (sort) => {
    setSort(sort);
    setPages(1);
  };
  useEffect(() => {
    getSportsList(isEmpty(page.curPage) ? 1 : page.curPage);
  }, [
    sort,
    page.curPage,
    sportId,
    location,
    league,
    pageInfo.gameType,
    searchType,
    searchValue,
  ]);

  const onShowMatch = useCallback(() => {
    // if (isMobilePage()) {
    //     window.addEventListener("scroll", mobileSportsWindowScrollHandler)
    // }
    setShowMatch(true);
    setShowMarkets(false);
  }, [showMatch, showMarkets]);

  const onShowMarket = useCallback(() => {
    setShowMatch(false);
    setShowMarkets(!showMarkets);
  }, [showMarkets, showMatch]);
  useEffect(() => {
    ResizeSportsLiveIframe();
    ResizeESportsIframe();
  }, [showMarkets]);

  useEffect(() => {
    // if(isMobilePage()){
    //     window.addEventListener("scroll", mobileSportsWindowScrollHandler);
    // }
    // if (!isEmpty($('#scroll_parent')[0])) {
    //     $('#scroll_parent')[0].addEventListener("scroll", pcSportScrollHandler);
    // }
    // return () => {
    //     clearInfiniteScroll();
    // }
    if (gamelists.length > 0) {
      console.log("ddddd", gamelists[0].FixtureId);
      store.dispatch(GetIframeUrl(gamelists[0].FixtureId));
    }
  }, [gamelists]);

  const setPage = (curPage) => {
    props.SetCurrentPage({ page: curPage, ...totalPage });
  };

  console.log("gameList", gamelists);
  console.log("url", url);
  return (
    <div className="contents_box_left">
      <Swipbox type={type} esport={esport} />
      <div className="sport_betting_area">
        <div style={{ margin: "auto", height: "auto", maxHeight: "550px" }}>
          <div className="sport_betting_area_box">
            {type === "prematch" ? (
              ""
            ) : (
              <div
                id={"sportsLive_iframe_parent"}
                data-v-183c8283=""
                data-v-69582644=""
                className="iframe-view row"
                style={{
                  display: "block",
                  position: "relative",

                  overflow: "hidden",
                }}
              >
                <iframe
                  className="frameScale"
                  scrolling="no"
                  frameBorder="0"
                  // width="100%"
                  // height="auto"
                  src={url}
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    border: 0,
                  }}
                  title={`${"sportsLive"}Iframe`}
                />
              </div>
            )}
          </div>
        </div>
        <div className="sport_betting_area_box">
          <div className="sport_table_head">
            <ul>
              <li className="sport_th1">
                {isEmpty(window.lang["날짜"]) ? "날짜" : window.lang["날짜"]}
              </li>
              <li className="sport_th2">
                {isEmpty(window.lang["승무패"])
                  ? "승무패"
                  : window.lang["승무패"]}
              </li>
              <li className="sport_th3">
                {isEmpty(window.lang["홈"]) ? "홈" : window.lang["홈"]}
              </li>
              <li className="sport_th4">
                {isEmpty(window.lang["배당율"])
                  ? "배당율"
                  : window.lang["배당율"]}
              </li>
              <li className="sport_th5">
                {isEmpty(window.lang["원정"]) ? "원정" : window.lang["원정"]}
              </li>
              <li className="sport_th6">
                {isEmpty(window.lang["더보기"])
                  ? "더보기"
                  : window.lang["더보기"]}
              </li>
            </ul>
          </div>
        </div>
        <div className="list-parent" style={isMobilePage() ? {} : listStyle}>
          <div
            className="sport_title_wrap"
            style={{ border: "none", minHeight: "10px" }}
          ></div>
          {gamelists.map((list, index) => {
            return (
              <Fragment key={list.FixtureId}>
                <Match
                  type={type}
                  key={list.FixtureId}
                  gamelist={list}
                  keyIndex={index}
                  onShowMarket={onShowMarket}
                  onShowMatch={onShowMatch}
                  onInteriorShowMarket={onInteriorShowMarket}
                  interiorShowMarket={interiorShowMarket === index}
                  showLeague={
                    index === 0
                      ? true
                      : list.Fixture.League.Id !==
                          gamelists[index - 1].Fixture.League.Id ||
                        list.Fixture.StartDate !==
                          gamelists[index - 1].Fixture.StartDate
                  }
                />
                <Markets
                  type={type}
                  showMarkets={showMarkets}
                  interiorShowMarket={interiorShowMarket === index}
                  onShowMarket={onShowMarket}
                />
              </Fragment>
            );
          })}
          <div
            className="sport_title_wrap"
            style={{ border: "none", minHeight: "50px" }}
          ></div>
        </div>
      </div>
      <div data-v-216d8a58="" className="pagination-out column">
        <div
          data-v-3badc2f2=""
          data-v-216d8a58=""
          className="pagination row"
          style={{ flexDirection: "row", alignItems: "center" }}
        >
          <div
            style={{ margin: "0px auto", width: "100%", paddingLeft: "10px" }}
          >
            <Pagenation
              page={page.curPage}
              totalPage={page.totalPage}
              getPage={setPage}
              perPage={100}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  sportsData: state.sports.data,
  location: state.sports.location,
  searchType: state.sports.searchType,
  searchValue: state.sports.searchValue,
  league: state.sports.league,
  sportId: state.sports.sportId,
  bet_setting: state.sports.bet_setting,
  baselineSetting: state.sports.baselineSetting,
  marketSetting: state.sports.marketSetting,
  page: state.page,
  isUp: state.page.isUp,
  totalPage: state.page.totalPage,
  pageInfo: state.page.pageInfo,
  url: state.sports.url,
});

export default connect(mapStateToProps, {
  SetLeague,
  SetLocation,
  SetCurrentPage,
  SetPerPage,
  AddSportsList,
})(SportsCenter);



// WEBPACK FOOTER //
// ./src/components/sports/SportsCenter.js